import type { ReactNode } from "react";
import { classNames } from "./internal/class-names";

export interface EmptyStateProps {
  readonly title: ReactNode;
  /** Why it is empty and what the user can do next. */
  readonly description?: ReactNode | undefined;
  readonly action?: ReactNode | undefined;
  readonly className?: string | undefined;
}

/**
 * Shown when a query legitimately returned nothing. Announced politely so a
 * screen-reader user learns the result of their own action.
 */
export function EmptyState({ action, className, description, title }: EmptyStateProps): ReactNode {
  return (
    <div className={classNames("thw-state", "thw-state--empty", className)} role="status">
      <p className="thw-state__title">{title}</p>
      {description === undefined ? null : (
        <p className="thw-state__description">{description}</p>
      )}
      {action}
    </div>
  );
}
